"use client";

import React from "react";

import { backdrop } from "./Backdrop.css";
import { ToggleButton } from "../ToggleButton";

type Props = JSX.IntrinsicElements["button"] & {
  "aria-controls": string;
};
export const Backdrop = (props: Props): JSX.Element => {
  return <ToggleButton {...props} className={backdrop} />;
};
